import React, { Component } from 'react';

import LeftCol from './LeftCol';
import RightCol from './RightCol';

class App extends Component {
  constructor(props) {
    super(props);
    const uuid = window.location.pathname.split('/').pop();
    const item = drupalSettings.dashboardData.find(element => (
      element.publicId === uuid
    ));
    this.state = {
      item,
    };
  }

  componentDidMount() {
    if (window.parent !== window.top) {
      let documentHeight = Math.max(
        document.body.scrollHeight, document.documentElement.scrollHeight,
        document.body.offsetHeight, document.documentElement.offsetHeight,
        document.body.clientHeight, document.documentElement.clientHeight
      );
      window.parent.postMessage('Height: ' + documentHeight, '*');
    }
  }

  render() {
    const { item } = this.state;
    let info = item.sections.find(element => element.sectionId === 'info');
    info = info ? info.fields : null;
    let propiedad = item.sections.find(element => element.sectionId === 'propiedad');
    propiedad = propiedad ? propiedad.fields : null;
    let contacto = item.sections.find(element => element.sectionId === 'info_contacto');
    contacto = contacto ? contacto.fields : null;
    let equipo = item.sections.find(element => element.sectionId === 'equipo_investigador');
    equipo = equipo ? equipo.fields : null;
    return (
      <div className="licensed-technology-node__wrapper">
        <div className="licensed-technology-node">
          {info && (
            <LeftCol
              title={item.title}
              info={info}
              image={item.imageFiles[0]}
              institution={item.tags[0]}
            />
          )}
          <RightCol
            institution={item.tags[0]}
            ip={propiedad}
            contact={contacto}
            team={equipo}
            template={item.template}
          />
        </div>
      </div>
    );
  }
}

export default App;
